const visuallyHidden = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
const visuallyHidden$1 = visuallyHidden;
export {
  visuallyHidden$1 as default
};
//# sourceMappingURL=visuallyHidden.es.js.map
